
export default {
  name: 'BaseProfileProductImagesItem',
  props: {
    image: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isShowFullViewButton: false,
    }
  },
  methods: {
    openFullImage() {
      setTimeout(() => {
        this.isShowFullViewButton = false
      }, 100)
      this.$refs.fullimage.open()
    },
  },
}
